import Splide from '@splidejs/splide';

if ($('#splide-awards-b2b').length > 0) {
  new Splide('#splide-awards-b2b', {
    type: 'loop',
    perPage: 6,
    perMove: 1,
    focus: 0,
    rewind: true,
    pagination: false,
    lazyLoad: 'sequential',
    easing: 'linear',
    autoplay: true,
    interval: 5000,
    breakpoints: {
      699: {
        perPage: 1,
      },
      992: {
        perPage: 3,
      },
      1279: {
        perPage: 4,
      },
    },
  }).mount();
}

if ($('#splide-notes-b2b').length > 0) {
  new Splide('#splide-notes-b2b', {
    type: 'loop',
    perPage: 2,
    perMove: 1,
    focus: 0,
    rewind: true,
    pagination: false,
    lazyLoad: 'sequential',
    easing: 'linear',
    autoplay: true,
    interval: 5000,
    breakpoints: {
      699: {
        perPage: 1,
      },
    },
  }).mount();
}
if ($('#healthcare-link').length > 0) {
  document.getElementById('healthcare-link').addEventListener('click', function (e) {
    e.preventDefault();

    const formElement = document.querySelector('.healthcare-form');
    const offsetTop = formElement.getBoundingClientRect().top + window.pageYOffset - 80;

    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth',
    });
  });
}

function scrollToForm(buttonId) {
  const button = document.getElementById(buttonId);
  if (button) {
    button.addEventListener('click', function () {
      const header = document.getElementById('header');
      const headerHeight = header ? header.offsetHeight : 0;
      const formBox = document.getElementById('formBox');
      const formBoxPosition = formBox.getBoundingClientRect().top + window.scrollY;

      window.scrollTo({
        top: formBoxPosition - headerHeight,
        behavior: 'smooth',
      });
    });
  }
}

if (document.getElementById('form-scroll') || document.getElementById('form-scroll2')) {
  scrollToForm('form-scroll');
  scrollToForm('form-scroll2');
}
